import { connect } from 'react-redux'
import { Thumbnail } from './Thumbnail.jsx'
import { jumpToMedia } from 'redux/navigation/actions'

const mapDispatchToProps = (dispatch, { position }) => ({
    onClick: () => dispatch(jumpToMedia(position)),
})

export const ThumbnailContainer = connect(
    undefined,
    mapDispatchToProps,
)(Thumbnail)
